import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-activitystatus',
  templateUrl: './manage-activitystatus.component.html',
  styleUrls: ['./manage-activitystatus.component.scss']
})

export class ManageActivityStatusComponent implements OnInit {
 
  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  taskStatusList: any[]=[];  
  value = ''; 
  paginatorTotalLength: any;
  dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  spinner:boolean=false;
  taskStatusID:number=0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
   this.getTastStatusList(); 
  }

  getTastStatusList() {
    this.loaderService.show();   
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getTouchTypeAndStatusess(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.taskStatusList = this.responseHolder.data;         
          if(this.taskStatusList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.taskStatusList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.taskStatusList=[];     
        this.loaderService.hide();
      }
    });
  } 


  openDialogAddWithRef(templateRef: TemplateRef<any>) {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('statusname', this.formBuilder.control(''));
    this.formDialog.addControl('constantname', this.formBuilder.control(''));  
    this.dialog.open(templateRef);     
  }

  onSearchChange(searchValue: string): void {
    const noSpecialCharacters = searchValue.replace(/[^a-zA-Z0-9 ]/g, '');
    const whitespace = noSpecialCharacters.replace(/\s+/g, "");
    this.formDialog.controls['constantname'].setValue(whitespace.toLowerCase());
  }
 
  
  AddTaskStatus(data) {
     let ReqModel = {
      taskStatusConstantName: data.constantname,
      taskStatusName: data.statusname,
      organizationID: Number(this.organizationId),    
      userID: this.currentUser.UID,    
      officeID:this.myOfficeID,
    }
    this.loaderService.show();   
    this.spinner=true;  
    this.formDialog.markAsPristine(); 
    this.settingsService.addTaskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner=false; 
          this.dialog.closeAll();
          this.toastr.success('Task status added successfully.', '', {
            timeOut: 3000,
          });
          this.getTastStatusList();
          this.loaderService.hide();
        }else{
          this.spinner=false; 
          this.loaderService.hide(); 
        }
      }else{
        this.spinner=false; 
        this.loaderService.hide(); 
      }
    });
  }

 
  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    let group = {};
    this.updateformDialog = new FormGroup(group);
    this.taskStatusID=task.taskStatusID;
    this.updateformDialog.addControl('statusname', this.formBuilder.control(''));
  //  this.updateformDialog.addControl('constantname', this.formBuilder.control(''));  

    this.updateformDialog.controls['statusname'].setValue(task.taskStatusName);
   // this.updateformDialog.controls['constantname'].setValue(task.taskStatusConstantName);

    this.dialog.open(templateRef); 
    this.updateformDialog.markAsPristine();
  }   


  UpdateTaskStatus(data) {
    let ReqModel = {
     taskStatusID:this.taskStatusID,
    // taskStatusConstantName: data.constantname,
     taskStatusName: data.statusname,
     organizationID: Number(this.organizationId),  
     userID: this.currentUser.UID,  
     officeID:this.myOfficeID,
   }
   this.loaderService.show();   
   this.spinner=true;  
   this.updateformDialog.markAsPristine(); 
   this.settingsService.renameTaskStatus(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;           
         this.toastr.success('Task status update successfully.', '', {
           timeOut: 3000,
         });
         this.getTastStatusList();   
         this.dialog.closeAll();       
         this.loaderService.hide();
       }else{
         this.spinner=false; 
         this.loaderService.hide(); 
         this.toastr.error('Task status update failed.', '', {
          timeOut: 3000,
        });
       }
     }else{
      this.spinner=false; 
      this.loaderService.hide(); 
      this.toastr.error('Task status update failed.', '', {
       timeOut: 3000,
     }); 
     }
   });
  }


 deleteStatusTask(task: any,statuses:any) {
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          touchTypeID:task.touchTypeID,
          touchStatusID:statuses.touchStatusID,        
          organizationID: Number(this.organizationId),  
          userID: this.currentUser.UID,  
          officeID:this.myOfficeID,
        }        
        this.settingsService.removeTouchStatus(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Status deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getTastStatusList();
              this.loaderService.hide();
            }
          }
        });
      }
    });
 }  
  

 UpdateStatusToggle(task: any, event: any) {
  this.loaderService.show();
  var ReqModel = {
    taskStatusID: task.taskStatusID,    
    activate: event.checked,
    organizationID: Number(this.organizationId),  
    userID: this.currentUser.UID,  
    officeID:this.myOfficeID,
  }
   this.settingsService.activateTaskStatus(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.toastr.success('Status updated successfully.', '', {
          timeOut: 3000,
        });
        this.getTastStatusList();
        this.loaderService.hide();
      }else{
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    }else{
      this.loaderService.hide();
      this.toastr.error('Status update failed.', '', {
        timeOut: 3000,
      });
    }
  });
 }


  close() {
    this.formDialog.reset();    
    this.dialog.closeAll();
  }

  closeUpdate(){
    this.updateformDialog.reset();
    this.dialog.closeAll();
  }

}
